var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-tabbar',{staticClass:"pt-tabbar__withData",attrs:{"data":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }